import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ICategory } from '../../interfaces/ICategory';
import { ISimpleHourRange } from '../../interfaces/ISimpleHourRange';
import { IItemSearchResumed } from '../../interfaces/IItemSearchResumed';

const apiUrl = Globals.apiPath + '/categories';

export default class CategoriesService {
  constructor() {}

  static async getAll({
    restaurantId,
  }: {
    restaurantId: number;
  }): Promise<ICategory[]> {
    let res = await axios.get<ICategory[]>(`${apiUrl}?r=${restaurantId}`);
    return res.data;
  }

  async getById(id: number): Promise<ICategory> {
    let res = await axios.get<ICategory>(`${apiUrl}/${id}`);
    return res.data;
  }

  async searchResumed(
    restaurantId: number,
    branchId: number,
    search: string = '',
    menuId: number | null | 'all'
  ): Promise<IItemSearchResumed[]> {
    let res = await axios.get<IItemSearchResumed[]>(
      `${apiUrl}/search/${encodeURIComponent(
        search ?? ''
      )}?r=${restaurantId}&b=${branchId}` + (menuId ? `&m=${menuId}` : '')
    );
    return res.data;
  }

  async create(category: ICategory): Promise<ICategory> {
    let res = await axios.post<ICategory>(apiUrl, category);
    return res.data;
  }

  async saveHours(categoryId: number, hours: ISimpleHourRange[]) {
    let res = await axios.put(`${apiUrl}/${categoryId}/hours`, { hours });
    return res.data;
  }

  async saveOrder(restaurantId: number, ids: number[], indexes: number[]) {
    let res = await axios.put(`${apiUrl}/saveOrder`, {
      restaurantId,
      ids,
      indexes,
    });
    return res.data;
  }

  async update(category: ICategory): Promise<ICategory> {
    let res = await axios.put<ICategory>(`${apiUrl}/${category.id}`, category);
    return res.data;
  }

  async delete(category: ICategory): Promise<ICategory> {
    let res = await axios.delete<ICategory>(`${apiUrl}/${category.id}`);
    return res.data;
  }

  async activate(category: ICategory): Promise<ICategory> {
    let res = await axios.post<ICategory>(`${apiUrl}/${category.id}/activate`);
    return res.data;
  }

  async deactivate(category: ICategory): Promise<ICategory> {
    let res = await axios.post<ICategory>(
      `${apiUrl}/${category.id}/deactivate`
    );
    return res.data;
  }
}
